<template>
  <div>
    <a
      href="#"
      class="btn btn-block btn-sm btn-rich m-b-10"
      :class="{ 'btn-primary': isActive, 'btn-default': !isActive }"
      @click="toggleActive"
    >
      <slot></slot>
      <span class="detail faded">
        <slot name="faded"></slot>
      </span>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * Renders block button-styled href, with btn-rich class
 * Provides default slot plus a faded slot which renders on the next line below default slot
 */
export default defineComponent({
  props: {
    /**
     * Starts as primary bg color
     */
    startActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: this.startActive,
    }
  },
  watch: {
    isActive() {
      this.$emit('changed-active', this.isActive)
    },
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    },
  },
})
</script>

<style scoped></style>
